import { render, staticRenderFns } from "./InForm.vue?vue&type=template&id=0887fd68&scoped=true"
import script from "./InForm.vue?vue&type=script&lang=js"
export * from "./InForm.vue?vue&type=script&lang=js"
import style0 from "./InForm.vue?vue&type=style&index=0&id=0887fd68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0887fd68",
  null
  
)

export default component.exports